const markerGreenBig = '<svg width="40" height="40" version="1.1" viewBox="0 0 10.583 10.583" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
    ' <defs>\n' +
    '  <linearGradient id="linearGradient2210-3-4" x1="159.02" x2="190.84" y1="28.999" y2="101.03" gradientTransform="matrix(.077099 0 0 .069305 -8.0809 .30418)" gradientUnits="userSpaceOnUse">\n' +
    '   <stop stop-color="#84BF41" offset="0"/>\n' +
    '   <stop stop-color="#009C50" offset="1"/>\n' +
    '  </linearGradient>\n' +
    ' </defs>\n' +
    ' <metadata>\n' +
    '  <rdf:RDF>\n' +
    '   <cc:Work rdf:about="">\n' +
    '    <dc:format>image/svg+xml</dc:format>\n' +
    '    <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>\n' +
    '    <dc:title/>\n' +
    '   </cc:Work>\n' +
    '  </rdf:RDF>\n' +
    ' </metadata>\n' +
    ' <g>\n' +
    '  <path d="m5.295 9.8484s4.1536-3.2615 4.1536-5.3445c0-2.0791-1.8457-3.7689-4.1225-3.7689h-0.01156-6.4e-6c-1.1361 0.0029067-2.3714 0.62076-3.1151 1.3006" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width=".94077" style="paint-order:stroke markers fill"/>\n' +
    '  <path d="m5.3234 1.1786c-2.0276 0.00518-3.6683 1.509-3.6683 3.3624 2.5e-6 1.857 3.6509 4.769 3.6509 4.769s3.7064-2.9117 3.7064-4.769c0-1.8574-1.647-3.36-3.6786-3.36h-0.010365z" fill="url(#linearGradient2210-3-4)" stroke-width="0"/>\n' +
    ' </g>\n' +
    '</svg>';

const markerYellowBig = '<svg width="40" height="40" version="1.1" viewBox="0 0 10.583 10.583" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
    ' <defs>\n' +
    '  <linearGradient id="linearGradient2414-2" x1="106.69" x2="207.3" y1="86.891" y2="165.76" gradientTransform="matrix(.072577 0 0 .069513 -4.1701 -1.0507)" gradientUnits="userSpaceOnUse">\n' +
    '   <stop stop-color="#f3ad28" offset="0"/>\n' +
    '   <stop stop-color="#f3ad28" stop-opacity="0" offset="1"/>\n' +
    '  </linearGradient>\n' +
    ' </defs>\n' +
    ' <metadata>\n' +
    '  <rdf:RDF>\n' +
    '   <cc:Work rdf:about="">\n' +
    '    <dc:format>image/svg+xml</dc:format>\n' +
    '    <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>\n' +
    '    <dc:title/>\n' +
    '   </cc:Work>\n' +
    '  </rdf:RDF>\n' +
    ' </metadata>\n' +
    ' <path d="m8.2656 1.9844c-0.70227-0.68395-1.8801-1.2627-2.9518-1.2627-0.0036-6.4e-6 -0.00719-6.4e-6 -0.010789 0h-9.77e-5c-2.139 0.00578-3.8699 1.6962-3.8699 3.7795 1.7e-6 2.0874 3.8515 5.3606 3.8515 5.3606" fill="none" stroke="#fff" stroke-linecap="round" stroke-width=".91414"/>\n' +
    ' <path d="m5.3114 1.1659c-1.9087 0.00514-3.4532 1.5136-3.4532 3.3725 2.1e-6 1.8626 3.4367 4.7833 3.4367 4.7833s3.489-2.9208 3.489-4.7833c0-1.8626-1.5504-3.3725-3.4628-3.3725-0.00321-5.2e-6 -0.00642-5.2e-6 -0.00976 0z" fill="url(#linearGradient2414-2)" stroke-width=".0041113"/>\n' +
    ' <text xmlns="http://www.w3.org/2000/svg" fill="#ffffff" font-family="Arial" font-size="5" transform="translate(-1.6, 0.1)" text-anchor="middle"><tspan x="7" y="6">*.*</tspan></text>\n' +
    '</svg>\n';

const markerGreenOutline = '<svg width="32" height="32" version="1.1" viewBox="0 0 8.4667 8.4667" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
    ' <defs>\n' +
    '  <linearGradient id="linearGradient2210-3-4" x1="159.02" x2="190.84" y1="28.999" y2="101.03" gradientTransform="matrix(.056507 0 0 .054122 -5.4003 .28345)" gradientUnits="userSpaceOnUse">\n' +
    '   <stop stop-color="#84BF41" offset="0"/>\n' +
    '   <stop stop-color="#009C50" offset="1"/>\n' +
    '  </linearGradient>\n' +
    ' </defs>\n' +
    ' <metadata>\n' +
    '  <rdf:RDF>\n' +
    '   <cc:Work rdf:about="">\n' +
    '    <dc:format>image/svg+xml</dc:format>\n' +
    '    <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>\n' +
    '    <dc:title/>\n' +
    '   </cc:Work>\n' +
    '  </rdf:RDF>\n' +
    ' </metadata>\n' +
    ' <g>\n' +
    '  <path d="m4.4031 7.7367s3.0442-2.5484 3.0442-4.1736c0-1.6252-1.3527-2.9426-3.0214-2.9426-0.00282-4e-6 -0.00565-4e-6 -0.00847 0h-4.8e-6c-0.83269 0.0023-1.738 0.48453-2.2831 1.0169" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width=".71173" style="paint-order:stroke markers fill"/>\n' +
    '  <path d="m4.4239 0.96629c-1.4861 4e-3 -2.6886 1.1785-2.6886 2.6258 1.8e-6 1.4502 2.6758 3.7242 2.6758 3.7242s2.7165-2.2741 2.7165-3.7242c0-1.4502-1.2071-2.6258-2.6961-2.6258-0.00254-4e-6 -0.00507-4e-6 -0.0076 0z" fill="url(#linearGradient2210-3-4)" stroke-width="0"/>\n' +
    ' </g>\n' +
    '</svg>';

const markerYellowOutline = '<svg width="32" height="32" version="1.1" viewBox="0 0 8.4667 8.4667" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
    ' <defs>\n' +
    '  <linearGradient id="linearGradient2414-4" x1="106.69" x2="207.3" y1="86.891" y2="165.76" gradientTransform="matrix(.056506 0 0 .054121 -2.958 -.75941)" gradientUnits="userSpaceOnUse">\n' +
    '   <stop stop-color="#f3ad28" offset="0"/>\n' +
    '   <stop stop-color="#f3ad28" stop-opacity="0" offset="1"/>\n' +
    '  </linearGradient>\n' +
    ' </defs>\n' +
    ' <metadata>\n' +
    '  <rdf:RDF>\n' +
    '   <cc:Work rdf:about="">\n' +
    '    <dc:format>image/svg+xml</dc:format>\n' +
    '    <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>\n' +
    '    <dc:title/>\n' +
    '   </cc:Work>\n' +
    '  </rdf:RDF>\n' +
    ' </metadata>\n' +
    ' <path d="m6.724 1.6036c-0.54677-0.53251-1.4638-0.98314-2.2982-0.98314-0.0028-4.2e-6 -0.0056-4.2e-6 -0.0084 0h-7.6e-5c-1.6654 0.00453-3.013 1.3207-3.013 2.9426 1e-6 1.6252 2.9987 4.1736 2.9987 4.1736" fill="none" stroke="#fff" stroke-linecap="round" stroke-width=".71173"/>\n' +
    ' <path d="m4.4239 0.96635c-1.4861 0.00404-2.6886 1.1785-2.6886 2.6258 2e-6 1.4502 2.6758 3.7242 2.6758 3.7242s2.7164-2.274 2.7164-3.7242-1.2071-2.6258-2.6961-2.6258c-0.0025-3.7e-6 -5e-3 -3.7e-6 -0.0076 0z" fill="url(#linearGradient2414-4)" stroke-width=".0032009"/>\n' +
    '<text xmlns="http://www.w3.org/2000/svg" fill="#ffffff" font-family="Arial" font-size="4" transform="translate(-1.5, 0)" text-anchor="middle"><tspan x="6" y="5">*.*</tspan></text>\n' +
    '</svg>\n';

const markerDefault = `<div class="marker"><div class="markerGreen">${markerGreenOutline}</div><div class="markerYellow">${markerYellowOutline}</div></div>`;
const markerSelected = `<div class="marker"><div class="markerGreen">${markerGreenBig}</div><div class="markerYellowSelected">${markerYellowBig}</div></div>`;

export { markerDefault, markerSelected };